export interface LLMStreamEvent {
  type: "chunk" | "done" | "error";
  content?: string;
  message?: string;
}

export async function readLLMStream(
  response: Response,
  onChunk: (fullText: string) => void,
): Promise<string> {
  if (!response.body) {
    throw new Error("Streaming response had no body");
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let fullText = "";

  while (true) {
    const { value, done } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const chunks = buffer.split("\n\n");
    buffer = chunks.pop() ?? "";

    for (const chunk of chunks) {
      const lines = chunk.split("\n");
      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed.startsWith("data:")) continue;
        const data = trimmed.slice(5).trim();
        if (!data) continue;
        try {
          const event = JSON.parse(data) as LLMStreamEvent;
          if (event.type === "chunk" && event.content) {
            fullText += event.content;
            onChunk(fullText);
          } else if (event.type === "error") {
            throw new Error(event.message || "Stream error");
          }
        } catch (error) {
          throw error instanceof Error ? error : new Error("Stream parse error");
        }
      }
    }
  }

  return fullText;
}
